<script setup lang="ts">
  import WondeurSection from '@/components/WondeurSection.vue';
  
  import { useHead } from 'unhead'
  
  useHead({
    title: 'Wondeur AI',
    meta: [
      { name: 'description', content: 'Global insurance and wealth management firms across 9 countries and 2 continents use our AIs to analyze risk on value for millions of alternative assets.' },
    ],
  });
</script>

<template>
  <main id="main">
    <wondeur-section>
      <template #header>
        <h2 class="light-text">What we&nbsp;do</h2>
      </template>
      <template #default>
        <p>
          We bring trust to the value of trillions of dollars in alternative assets.
          <span class="light-text"
            >Our models analyze risk and biases on multiple value dimensions for both illiquid and
            liquid assets, addressing speculative, mispricing, future risks on values and more,
            at&nbsp;scale.</span
          >
        </p>
      </template>
    </wondeur-section>

    <wondeur-section class-list="light-bg rounded gif-knowledge-grey">
      <template #header>
        <h2 class="light-text">Introducing our latest AI&nbsp;systems</h2>
        <p>WOND-A&nbsp;9</p>
      </template>
      <template #default>
        <p>
          Designed and trained specifically for the financial industry dealing with art assets.
          <span class="light-text"
            >It analyzes and monitors risk on value for millions of art assets (illiquid or liquid),
            providing an analysis depth that is <span class="gradient-text">50 times</span> greater
            and a scope <span class="gradient-text">70 times</span> broader than any
            existing&nbsp;solution.</span
          >
        </p>
        <p>
          Our client roster includes global insurance and wealth management firms across
          <span class="gradient-text">9 countries</span> and
          <span class="gradient-text">2 continents</span>.
          <span class="light-text"
            >They leverage our latest WOND-A models to provide insurance value risk monitoring and
            unique services to all their clients, instead of just a few. These models power their
            revenue growth without requiring IT&nbsp;investment.</span
          >
        </p>
        <div class="btn-wrapper">
          <router-link to="/insurance">Insurers</router-link>
          <router-link to="/wealth-management">Wealth Managers</router-link>
        </div>
      </template>
    </wondeur-section>

    <wondeur-section>
      <template #header>
        <h2 class="light-text">Our&nbsp;vision</h2>
      </template>
      <template #default>
        <p>
          We want alternative assets worth trillions of dollars to be trusted for their value,
          <span class="light-text"
            >leveraged and made liquid at a fair value to benefit the entire ecosystem—from
            financial players and creators to distributors and&nbsp;collectors.</span
          >
        </p>
      </template>
    </wondeur-section>

    <wondeur-section>
      <template #header>
        <h2 class="light-text">Empowering you and your&nbsp;network</h2>
      </template>
      <template #default>
        <p>
          We are the engine, you are the driver.
          <span class="light-text"
            >Our AI systems are human-controlled, accountable, open-box; they are building, scaling,
            and speeding up expertise without replacing it. This approach makes our AI systems
            accessible and empowering throughout your internal and external network of stakeholders
            all the way down to your&nbsp;clients.</span
          >
        </p>
      </template>
    </wondeur-section>

    <wondeur-section>
      <template #header>
        <h2 class="light-text">Research-led</h2>
      </template>
      <template #default>
        <p>
          <span class="gradient-text">85% of our spending</span> is dedicated to research.
          <span class="light-text"
            >We conduct frontier research and deploy it through a set of partnerships and products
            in the US and Europe, and soon across&nbsp;Asia.</span
          >
        </p>
        <div class="btn-wrapper">
          <router-link to="research-team">Research &amp; Team</router-link>
        </div>
      </template>
    </wondeur-section>
  </main>
</template>

<style scoped>
.btn-wrapper {
  display: flex;
  gap: 4rem;
}
</style>
